import React, { useState } from 'react';
import { Button, Form, Input, message} from 'antd';
import env from 'utils/env';
import './forgetPassword.css';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ForgetPassword: React.FC = () => {
  const { elsaIcon } = env();
  const { t } = useTranslation();
  const [resetLoading, setResetLoading] = useState(false);
  const navigate = useNavigate();
  const onSubmitResetPassword = (values: any) => {
     const config = {
      headers: {
        'content-type': 'application/json'
      }
    };
    const {email} = values;
    setResetLoading(true);
    axios
      .get(`${env().userServerApiUrl}/user/api/v1/password/reset?e=${email}`, config)
      .then((res) => {
        message.success(`${t('reset.success', {email: email})}`);
        setResetLoading(false);
        navigate(`/${t('slug.login')}`);
      })
      .catch((err) => {
        message.error(err.response?.data?.message || 'There was an error! Please try again later.');
        setResetLoading(false);
      });
  };
  return (
    <div className="signin-container">
      <Helmet>
        <title>Forget Password - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App forget password on web PC. Redeem promo code ELSA Pro, Oxford Business Result, ELSA for Students, ELSA Speak free."
        />
      </Helmet>
      <div className="logo">
        <img alt="logo" src={elsaIcon} />
      </div>
      <div className="form-container form-forget">
        <h1>{t('reset.forgot_password')}</h1>
        <Form layout="vertical" onFinish={onSubmitResetPassword}>
          <Form.Item
          name="email"
          rules={[
            {
            type: 'email',
            required: true,
            message: 'Vui lòng nhập địa chỉ Email'
            }
          ]}
          >
          <Input placeholder="Email" />
          </Form.Item>
          <Button
          htmlType="submit"
          className="submit-button"
          loading={resetLoading}
          >
          {t('reset.send_require')}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ForgetPassword;
